
// You can write more code here

/* START OF COMPILED CODE */

import BaseScene from "../core/scenes/BaseScene";
import TransitionScene from "../prefabs/TransitionScene";
/* START-USER-IMPORTS */
import { SceneData, SceneId, TransitionSceneData } from '../rooting';
/* END-USER-IMPORTS */

export default class TransitionLoadScene extends BaseScene {

  constructor() {
    super("TransitionLoadScene");

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {

    // transitionPrefab
    const transitionPrefab = new TransitionScene(this, 937, 395);
    this.add.existing(transitionPrefab);
    transitionPrefab.alpha = 1;

    this.transitionPrefab = transitionPrefab;

    this.events.emit("scene-awake");
  }

  private transitionPrefab!: TransitionScene;

  /* START-USER-CODE */

  private sceneData!: SceneData;
  private transitionSceneData!: TransitionSceneData;

  init(data: SceneData) {
    super.init(data);

    let transitionDefaults: TransitionSceneData = {
      sourceScene: this.scene.key,
      nextScene: SceneId.Title
    };

    this.transitionSceneData = Object.assign({}, transitionDefaults, data.transitionData);
    this.sceneData = data;
    // this.sceneData.transitionData = undefined;

    // this.scene.bringToTop(this);
  }

  create() {
    this.editorCreate();

    let targetScene = this.scene.get(this.transitionSceneData.nextScene);

    if (targetScene) {
      targetScene.events.once(Phaser.Scenes.Events.CREATE, () => {
        this.events.emit(BaseScene.transitionEvents.TransitionUncovering);
        this.transitionPrefab.hide();
      });
    }

    this.events.emit(BaseScene.transitionEvents.TransitionCovering);
    this.transitionPrefab.show(() => {
      this.events.emit(BaseScene.transitionEvents.TransitionCovered);
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
